import React from 'react';
import {render} from 'react-dom';

import ReviewsPage from './ReviewsPage';

// Tutoriage `/reviews` legacy template (templates/reviews.phtml on
// the TA repo) used to server-render the full list + jQuery-driven
// form. The PHP shell now leaves just a mount root plus this bundle's
// <script> tag; everything visual is React-driven from here.
//
// No Redux store, no SCSS bundle, no shared <Header /> — the page
// header / footer continue to be PHP-rendered by the tutoriage shell
// (light layout). We only own the inner `<main class="page testimonials wrap">`
// region so the existing brand chrome stays untouched.
const mount = () => {
    const root = document.getElementById('reviews-page-root');
    if (root) render(<ReviewsPage/>, root);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
} else {
    mount();
}
